<template>
<div>
  <form>
    <div class="columns">
      <div class="column">
        <text-input 
          :value="environment.name"
          :error="$root.errorBag.name"
          @input="updateName">
          Name
        </text-input>
      </div>
      <div class="column">
        <text-input 
          classes="has-addons"
          :value="environment.public_url"
          :error="$root.errorBag.public_url"
          @input="updatePublicUrl"
          hint="Changing this value will trigger a TLS scan">
          <template #left>
            <button class="button is-static">https://</button>
          </template>
          Public URL
        </text-input>
      </div>
      <column class="is-narrow is-flex align-end">
        <div class="buttons has-addons">
          <action-button @click="openClientRegenerator()">
            <icon icon="sync"/>
            <span>Regnerate Client</span>
          </action-button>
          <action-button v-if="!environment.is_production" @click="makeProduction()">
            <icon icon="star"/>
            <span>Make Production</span>
          </action-button>
        </div>
      </column>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button 
          :disabled="!$root.can('edit_environments', app.account_id)"
          left-icon="save" 
          :working="saving" 
          @submit="update">
          Save
        </submit-button>
      </div>
      <div class="column is-narrow is-flex align-end">
        <action-button
          :disabled="!$root.can('delete_environments', app.account_id)"
          :working="deleting"
          class="is-danger is-small" 
          left-icon="trash"
          @click="deleteEnvironment">
          Delete
        </action-button>
      </div>
    </div>
  </form>  
</div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { regenerateClient } from '@/api/environment'
import { clientConfig } from '@/modals'

export default {

  data: () => ({
    saving: false,
    deleting: false
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Edit')
  },

  methods: {
    ...mapMutations('environment', [
      'updateName',
      'updatePublicUrl'
    ]),
    update() {
      this.saving = true
      this.$store.dispatch('environment/update').then(() => {
        this.saving = false
        this.$toast.success('Saved')
      }).catch(() => {
        this.saving = false
        this.$toast.success('Whoops, something went wrong please try again.')
      })
    },
    async deleteEnvironment() {
      if(await this.$confirm({
        title: 'Delete Environment',
        message: 'Are you sure you want to delete this environment?'
      })) {
        this.deleting = true
        this.$store.dispatch('environment/deleteEnv', this.environment.id).then(() => {
          this.deleting = false
          this.$toast.success('Environment Deleted')
          this.$router.push({
            name: 'app-environments',
            params: this.$route.params
          })
        }).catch(error => this.deleting = false)
      }
    },
    async openClientRegenerator() {
      if(await this.$confirm({
        title: 'Regenerate Client',
        message: 'Are you sure you want to regenerate the auth client? This will revoke all currently active clients on this enviroment'
      })) {
        regenerateClient(this.environment.id, ({data}) => {
          clientConfig(data)
        }, error => {})
      }
    },
    async makeProduction() {
      if(await this.$confirm({
        title: 'Change Production Environment',
        message: 'Are you sure you want to make this environment the production env? All current sessions will be terminated.'
      })) {
        this.$store.dispatch('environment/makeProduction', this.environment.id).then(() => {
          this.$toast.success('Environment is now Production')
        }).catch(error => {})
      }
    }
  },
  
  computed: {
    ...mapGetters('environment', [
      'environment'
    ]),
    ...mapGetters('app', [
      'app'
    ])
  }

}
</script>